import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Card, Form } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { useLocalStorage } from 'react-use';
import useNotif from 'hooks/use-notify-hook';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import './Auditor.css';

export default function Auditor({auditorTeams = [], disabled, onChange}) {

  const { scheduleId } = useParams();

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [isLoading, setIsLoading] = useState(false);
  const [head, setHead] = useState(-1);
  const [options, setOptions] = useState([]);

  const handleSearch = async (query) => {

    try {

      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}auditors`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          AUDITOR_STATUS: 'Active',
          search: query,
          expand: 'employee.user',
        }
      });

      setOptions(response.data.items);
      setIsLoading(false);

    } catch (error) {

      console.log(error);
      alert('error');
    }
  }


  const handleChangeMembers = async selected => {

    try {

      const removed = auditorTeams.find(member => !selected.includes(member));
      const added = selected.find(item => !auditorTeams.includes(item));

      if (added) {

        /** Prevent duplicate team members */
        if (auditorTeams.find(member => member.AUDITOR_ID === added.AUDITOR_ID)) {
          return dispatchNotif({
            place: `br`,
            message: `Auditor team member already set.`,
            type: `danger`,
          });
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST}auditor-teams`,
          {
            SCHEDULE_ID: scheduleId,
            AUDITOR_ID: added.AUDITOR_ID
          },
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params: {
              expand: 'auditor.employee.user',
            }
          }
        );

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return onChange([...auditorTeams, { ...response.data }]);
      }

      if (removed) {

        const response = await axios.delete(`${process.env.REACT_APP_API_HOST}auditor-teams/${removed.AUDITOR_TEAM_ID}`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return onChange(selected);
      }

    } catch (error) {

      alert(`error`);
      console.log(error);

    }
  }


  const handleChangeHead = async ({target: {value} }) => {

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}auditor-teams/${value}/head`,
        {SCHEDULE_ID: scheduleId},
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

      onChange(auditorTeams.map(auditor => {
        if (auditor.AUDITOR_TEAM_ID === parseInt(value)) {
          return {
            ...auditor,
            AUDITOR_TYPE_ID: 2
          }
        }

        return {
          ...auditor,
          AUDITOR_TYPE_ID: 1
        }
      }))

      setHead(parseInt(value));

    } catch (error) {
      alert(error);
      console.log(error);
    }
  }

  useEffect(() => {
    if (auditorTeams && auditorTeams.find(member => member.AUDITOR_TYPE_ID == 2)?.AUDITOR_TEAM_ID) {
      setHead(auditorTeams.find(member => member.AUDITOR_TYPE_ID == 2).AUDITOR_TEAM_ID)
    } else  {
      setHead(-1);
    }
  }, [auditorTeams]);

  return (
    <Card>
      {notif}
      <Card.Header>
        <Card.Title>Auditor Member(s)</Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group>
          <Form.Label>Type Name/Email</Form.Label>
          <AsyncTypeahead
            disabled={disabled}
            multiple
            filterBy={() => true}
            id="auditor-typehead"
            isLoading={isLoading}
            labelKey={(key) => {
              if (key?.auditor !== undefined) {
                return key.auditor.employee.EMP_NAME;
              }

              return key.employee.EMP_NAME;
            }}
            minLength={1}
            onChange={handleChangeMembers}
            selected={auditorTeams}
            onSearch={handleSearch}
            options={options}
            placeholder="Search for an employee..."
            renderMenuItemChildren={(key) => {
              if (key?.auditor !== undefined) {
                return (
                  <div>
                    {key.auditor.employee.EMP_NAME}
                    <div>
                      <small>{key.auditor.employee.EMP_EMAIL}</small>
                    </div>
                  </div>
                );
              }

              return (
                <div>
                  {key.employee.EMP_NAME}
                  <div>
                    <small>{key.employee.EMP_EMAIL}</small>
                  </div>
                </div>
              )
            }}
          />
        </Form.Group>
        <Form.Group>
        <Form.Label>Head of Auditor Team</Form.Label>
          <Form.Control
            disabled={disabled}
            value={head}
            defaultValue={-1}
            as="select"
            onChange={handleChangeHead}
          >
            <option value={-1} disabled>Select Head of Auditor</option>
            {auditorTeams && auditorTeams.map((member, key) => (
              <option key={key} value={member.AUDITOR_TEAM_ID}>{member.auditor.employee.EMP_NAME}</option>
            ))}
          </Form.Control>
        </Form.Group>
      </Card.Body>
    </Card>
  );
}